const GlobalAlerts = require('global_alerts');
const Card = require('card');
const Lang = require('lang');

exports.init = function Pagamento() {

  const $paymentForm = $('#payment-form');
  const assinar = document.getElementById('assinar');
  const number = document.getElementById('number');
  const cvc = document.getElementById('cvc');
  const expiry = document.getElementById('expiry');
  const cardHash = document.getElementById('cardHash');
  const invoiceId = document.getElementById('invoiceId');
  const userName = document.getElementById('nomeCartao');

  // Credit card form shenanigans
  const cardForm = new Card({
    form: $paymentForm.get(0),
    container: '#card-container',
    width: '100%',
    formSelectors: {
      cvcInput: '#cvc',
      nameInput: '#nomeCartao',
      numberInput: '#number',
      expiryInput: '#expiry'
    },
    placeholders: {
      number: '•••• •••• •••• ••••',
      name: Lang.get('js/src/functions/Pagamento.name_on_card'),
      expiry: '••/••••',
      cvc: '•••'
    },
  });

  const finalizarAssinatura = function() {
    nifty.body.overlay({
      title: Lang.get('js/src/functions/Pagamento.processing_payment')
    });
    nifty.body.overlay('show');

    const postData = {
      invoiceId: invoiceId.value,
      cardHash: cardHash.value
    };

    $.post($paymentForm.attr('action'), postData)
      .done(function(data) {
        GlobalAlerts.create({
          title: Lang.get('js/src/functions/Pagamento.success'),
          message: Lang.get('js/src/functions/Pagamento.information_successfully_inserted')
        });

        nifty.body.overlay('hide');
        location.href = route('app.settings.financeiro.index');
      })
      .fail(function(error) {
        const message = error.responseJSON.message || Lang.get('js/src/functions/Pagamento.payment_error');

        assinar.disabled = false;
        nifty.body.overlay('hide');

        GlobalAlerts.createAndShow({
          type: 'danger',
          title: Lang.get('js/src/functions/Pagamento.ops'),
          message: message,
        });
      })
      .always(function() {
        nifty.body.overlay({
          title: Lang.get('js/src/functions/Pagamento.loading')
        });
      });
  }

  if ($paymentForm.length) {
    assinar.addEventListener('click', function() {
      const [expMonth, expYear] = expiry.value.split('/');
      const fragmentedName = userName.value.split(' ');
      const firstName = fragmentedName.shift();
      const lastName = fragmentedName.join(' ');

      if (!$paymentForm.valid()) {
        return;
      }

      const cc = Iugu.CreditCard(
        number.value,
        expMonth.trim(),
        expYear.trim(),
        firstName,
        lastName,
        cvc.value
      );

      if (!cc.valid()) {
        bootbox.alert({
          title: Lang.get('js/src/functions/Pagamento.invalid_card'),
          message: Lang.get('js/src/functions/Pagamento.invalid_card_data'),
          size: 'small'
        });

        return;
      }

      Iugu.createPaymentToken(
        cc,
        response => {
          if (response.errors) {
            bootbox.alert({
              title: Lang.get('js/src/functions/Pagamento.ops'),
              message: Lang.get('js/src/functions/Pagamento.error_contact_iugu_try_again'),
              size: 'small'
            });

            return;
          }

          cardHash.value = response.id;
          assinar.disabled = true;
          finalizarAssinatura();
        }
      );
    });
  }

}


/**
 * on url...
 */
exports.url = /\/settings\/financeiro\/pagar-fatura\//;

